// extracted by mini-css-extract-plugin
export default {"deadEndContainer":"DeadEnd_deadEndContainer__zuPaE","heading":"DeadEnd_heading__O8JRL","subText":"DeadEnd_subText__5wEuy","backToStart":"DeadEnd_backToStart__1Q0UI"};